<template>

  <span class="w-link-page-back">
    <a class="link-page-back" :href="getLinkPageBack">
      {{trans.get('generals.page.back')}}
    </a>
  </span>


</template>

<script>
export default{

  props: {

    page: {
      type: String,
      default: 'home'
    },

    meta: {
      type: [Object, String],
      default: null,
    }

  },

  data: function(){
    return {

    }
  },

  computed: {

    getLinkPageBack()
    {
      switch (this.page) {

        case 'macrofamily':
        if(this.meta)
          return this.url('/macrofamily-article/'+this.meta);
        break;

        case 'family':
          if(this.meta)
            return this.url('/family-article/'+this.meta);
        break;

        case 'home':
        default:
          return this.url('/');
        break;

      }

      return this.url('/');

    }

  },

  methods: {


  }

}
</script>

<style scoped>

.w-link-page-back {
    display: block;
    position: relative;
    margin: 0 0 2em;
}

a.link-page-back {
  display: block;
  width: 100px;
  font-size: 1.1em;
  color: white;
  font-weight: 400;
  position: relative;
  padding-left: 6em;
}

a.link-page-back::before {
  content: "";
  width: 67px;
  height: 21px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: url("/media/icons/svg/arrow-right_white.svg");
  background-color: transparent;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: initial;
  background-size: contain;
  background-position: bottom;
  transform: rotateY(180deg);
}

</style>
